import { createStructuredSelector } from 'reselect';
import { areActionsDisabled, artboardScale } from 'containers/App/selectors';
import { layeredRelations } from 'containers/Relations/selectors';

export const spacerSelector = createStructuredSelector({
  areActionsDisabled,
  relations: layeredRelations,
  scale: artboardScale,
});
